import React, { useEffect, useState } from 'react'
import { XCircleFill } from 'react-bootstrap-icons'

import { colors } from '../../../constants/salesStyles'
import useHoverHandler from '../../../hooks/sales/useHoverHandler'
import ImageRotateControls from '../ImageRotateControls/ImageRotateControls'

import styles from './styles.module.scss'

interface IProps {
    file: File
    index: number
    previewAngle: number
    isSaving?: boolean
    removeFile: (index: number) => void
    onRotate: (index: number) => void
    setActiveImageIndex: (index: number) => void
}

const SalesThumbPreview = ({
    file,
    index,
    previewAngle,
    isSaving = false,
    removeFile,
    onRotate,
    setActiveImageIndex,
}: IProps) => {
    const getImagePreviewThumb = (imageFile: File) => URL.createObjectURL(imageFile)
    const getMarginRight = (fileIndex: number) => ((fileIndex + 1) % 5 === 0 && fileIndex !== 0 ? '0px' : '6px')
    const [isHover, hoverOn, hoverOff] = useHoverHandler()
    const [previewUrl, setPreviewUrl] = useState(() => getImagePreviewThumb(file))
    const isPending = previewAngle > 0

    useEffect(() => {
        const url = getImagePreviewThumb(file)
        setPreviewUrl(url)

        return () => URL.revokeObjectURL(url)
    }, [file])

    return (
        <div
            key={file.name + index}
            className={styles.wrap}
            onMouseLeave={hoverOff}
            onMouseOver={hoverOn}
            style={{
                marginRight: getMarginRight(index),
            }}
        >
            <ImageRotateControls
                previewAngle={previewAngle}
                isDisabled={isSaving}
                onRotate={() => onRotate(index)}
            >
                <img
                    src={previewUrl}
                    alt="upload image"
                    className={styles.thumbPreview}
                    onClick={() => {
                        setActiveImageIndex(index)
                    }}
                />
            </ImageRotateControls>
            {isHover && !isPending ? (
                <span onClick={() => removeFile(index)} className={styles.clearIcon}>
                    <XCircleFill color={colors.white} size={18} />
                </span>
            ) : null}
        </div>
    )
}

export default SalesThumbPreview
